interface FilterSidebarProps {
  subCategories: string[];
  subCategory: string | null;
  regions: string[];
  region: string | null;
  years: number[];
  year: number | null;
  onSubChange: (value: string | null) => void;
  onRegionChange: (value: string | null) => void;
  onYearChange: (value: number | null) => void;
  onReset: () => void;
}

const chipBase = "rounded-full px-3 py-1.5 text-sm transition-colors whitespace-nowrap cursor-pointer";
const chipActive = "bg-primary-500 text-background-50";
const chipIdle = "bg-background-100 text-foreground-700 hover:bg-background-200";

export default function FilterSidebar({
  subCategories,
  subCategory,
  regions,
  region,
  years,
  year,
  onSubChange,
  onRegionChange,
  onYearChange,
  onReset,
}: FilterSidebarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-heading font-semibold text-foreground-950">筛选条件</h3>
        <button
          type="button"
          onClick={onReset}
          className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
        >
          <i className="ri-refresh-line"></i>
          重置
        </button>
      </div>

      <div className="mt-5 space-y-6">
        <div>
          <p className="mb-3 text-xs font-label text-foreground-400">子分类</p>
          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={() => onSubChange(null)}
              className={`${chipBase} ${subCategory === null ? chipActive : chipIdle}`}
            >
              全部
            </button>
            {subCategories.map((sub) => (
              <button
                key={sub}
                type="button"
                onClick={() => onSubChange(sub)}
                className={`${chipBase} ${subCategory === sub ? chipActive : chipIdle}`}
              >
                {sub}
              </button>
            ))}
          </div>
        </div>

        <div>
          <p className="mb-3 text-xs font-label text-foreground-400">地区</p>
          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={() => onRegionChange(null)}
              className={`${chipBase} ${region === null ? chipActive : chipIdle}`}
            >
              全部
            </button>
            {regions.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => onRegionChange(item)}
                className={`${chipBase} ${region === item ? chipActive : chipIdle}`}
              >
                {item}
              </button>
            ))}
          </div>
        </div>

        <div>
          <p className="mb-3 text-xs font-label text-foreground-400">年份</p>
          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={() => onYearChange(null)}
              className={`${chipBase} ${year === null ? chipActive : chipIdle}`}
            >
              全部
            </button>
            {years.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => onYearChange(item)}
                className={`${chipBase} ${year === item ? chipActive : chipIdle}`}
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}